import { ReactNode } from 'react';
import { AsyncState } from 'react-use/lib/useAsync';
import { Button, Skeleton, Tooltip, TooltipTrigger } from '@backstage/ui';

/** A cell whose data comes from its own request: a skeleton while pending, `-` with the error on hover if it failed. */
export const AsyncCell = ({
  state,
  children,
}: {
  state: AsyncState<unknown>;
  children: () => ReactNode;
}) => {
  if (state.loading) {
    return <Skeleton width={96} height={20} />;
  }
  if (state.error) {
    return (
      <TooltipTrigger>
        <Button variant="tertiary" size="small">
          -
        </Button>
        <Tooltip>{state.error.message}</Tooltip>
      </TooltipTrigger>
    );
  }
  return <>{children()}</>;
};
